import React from 'react';
import { Col } from 'react-bootstrap';
import DownloadInvoice from 'containers/request/Payments/DownloadInvoice';
import StaffSubmitButton from 'containers/request/Payments/StaffSubmitButton';

const PaymentActions = () => {
  return (
    <div>
      <hr />
      <Col xs={12} sm={9} md={9} mdOffset={3} smOffset={3}>
        <StaffSubmitButton />
        <DownloadInvoice />
      </Col>
    </div>
  );
};

export default PaymentActions;



// WEBPACK FOOTER //
// ./src/containers/request/Payments/PaymentActions.js